import { APIManager, AppPreference, axios } from 'shared/manager';
import { RestEnds } from 'shared/Constants';

/**
 * Sends a POST request to newly register.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const register = async (data: any): Promise<any> =>
    APIManager.sendPost(RestEnds.REGISTER, data, false, {}, {}, axios);
/**
 * Sends a POST request to login.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const login = async (data: any): Promise<any> =>
    APIManager.sendPost(RestEnds.LOGIN, data, false, {}, {}, axios);

/**
 * Sends a POST request to login Azure Active Directory.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */

const loginAAD = async (data: any): Promise<any> =>
    APIManager.sendPost(RestEnds.LOGIN_AAD, {}, false, data, {}, axios);

/**
 * Sends a POST request to send new mail for authentication flow.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const resendEmail = async (data: any): Promise<any> =>
    APIManager.sendPost(RestEnds.RESEND_EMAIL, data, false, {}, {}, axios);

/**
 * Patch a user to readily entries to forgot password procedure.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const forgotPassword = async (data: any): Promise<any> =>
    APIManager.sendPatch(RestEnds.FORGOT_PASSWORD, data, false, {}, {}, axios);
/**
 * Patch a user to readily entries to reset password procedure.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const resetPassword = async (data: any): Promise<any> =>
    APIManager.sendPatch(RestEnds.RESET_PASSWORD, data, false, {}, {}, axios);
/**
 * Sends a POST request to logout.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const logout = async (headers = {}, config = {}): Promise<any> =>
    APIManager.sendPatch(RestEnds.LOGOUT, {}, true, headers, config, axios);
/**
 * Clear user token on authentication.
 * @returns {Promise<any>} The promise that resolves with the redux status.
 */
const clearToken = async (): Promise<any> => AppPreference.clearToken();

export const AuthenticationService = {
    register,
    login,
    resendEmail,
    forgotPassword,
    resetPassword,
    logout,
    clearToken,
    loginAAD,
};
